import React, { Component } from 'react';
import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import { ExitToAppSharp } from '@mui/icons-material';

export const COLORS = [
    "#ef9a9a",
    "#F48FB1",
    "#CE93D8",
    "#B39DDB",
    "#9FA8DA",
    "#90CAF9",
    "#81D4FA",
    "#80DEEA",
    "#80CBC4",
    "#A5D6A7",
    "#C5E1A5",
    "#E6EE9C",
    "#FFF59D",
    "#FFE082",
    "#FFCC80",
    "#FFAB91",
    "#BCAAA4",
    "#EEEEEE",
    "#B0BEC5",
    "#e57373",
    "#F06292",
    "#BA68C8",
    "#9575CD",
    "#7986CB",
    "#64B5F6",
    "#4FC3F7",
    "#4DD0E1",
    "#4DB6AC",
    "#81C784",
    "#AED581",
    "#DCE775",
    "#FFF176",
    "#FFD54F",
    "#FFB74D",
    "#FF8A65",
    "#A1887F",
    "#E0E0E0",
    "#90A4AE",
    "#ef5350",
    "#EC407A",
    "#AB47BC",
    "#7E57C2",
    "#5C6BC0",
    "#42A5F5",
    "#29B6F6",
    "#26C6DA",
    "#26A69A",
    "#66BB6A",
    "#9CCC65",
    "#D4E157",
    "#FFEE58",
    "#FFCA28",
    "#FFA726",
    "#FF7043",
    "#8D6E63",
    "#BDBDBD",
    "#78909C",
    "#f44336",
    "#E91E63",
    "#9C27B0",
    "#673AB7",
    "#3F51B5",
    "#2196F3",
    "#03A9F4",
    "#00BCD4",
    "#009688",
    "#4CAF50",
    "#8BC34A",
    "#CDDC39",
    "#FFEB3B",
    "#FFC107",
    "#FF9800",
    "#FF5722",
    "#795548",
    "#9E9E9E",
    "#607D8B",
    "#e53935",
    "#D81B60",
    "#8E24AA",
    "#5E35B1",
    "#3949AB",
    "#1E88E5",
    "#039BE5",
    "#00ACC1",
    "#00897B",
    "#43A047",
    "#7CB342",
    "#C0CA33",
    "#FDD835",
    "#FFB300",
    "#FB8C00",
    "#F4511E",
    "#6D4C41",
    "#757575",
    "#546E7A",
    "#d32f2f",
    "#C2185B",
    "#7B1FA2",
    "#512DA8",
    "#303F9F",
    "#1976D2",
    "#0288D1",
    "#0097A7",
    "#00796B",
    "#388E3C",
    "#689F38",
    "#AFB42B",
    "#FBC02D",
    "#FFA000",
    "#F57C00",
    "#E64A19",
    "#5D4037",
    "#616161",
    "#455A64",
    "#c62828",
    "#AD1457",
    "#6A1B9A",
    "#4527A0",
    "#283593",
    "#1565C0",
    "#0277BD",
    "#00838F",
    "#00695C",
    "#2E7D32",
    "#558B2F",
    "#9E9D24",
    "#F9A825",
    "#FF8F00",
    "#EF6C00",
    "#D84315",
    "#4E342E",
    "#424242",
    "#37474F",
    "#b71c1c",
    "#880E4F",
    "#4A148C",
    "#311B92",
    "#1A237E",
    "#0D47A1",
    "#01579B",
    "#006064",
    "#004D40",
    "#1B5E20",
    "#33691E",
    "#827717",
    "#F57F17",
    "#FF6F00",
    "#E65100",
    "#BF360C",
    "#3E2723",
    "#212121",
    "#263238",
]

class ColorPicker extends Component {
    state = {  }
    
    displayList = () => {
        let tab = []
        if (this.props.small){
                tab.push(
                    <TableRow key={"line2"} >{this.displayColumns(2, 0, 15, 2)}</TableRow>  
                )          
        } else if (this.props.max){        
            for( let line = 0; line < 8; line++ ){
                tab.push(
                    <TableRow key={line} >{this.displayColumns(line, 0, this.props.max)}</TableRow>  
                )          
            }
        } else {
            for( let line = 0; line < 8; line++ ){
                tab.push(
                    <TableRow key={line} >{this.displayColumns(line)}</TableRow>  
                )          
            }
        }
        return tab
    }
    displayColumns = (line, start = 0, max = 19, step = 1) => {
        const { notAvailable } = this.props;
        let tab = []
        for( let col = start; col < max; col += step ){
            let color = COLORS[(line * 19 + col)]
            if ( notAvailable.includes(color) ){
                tab.push(
                    <TableCell
                        key={color} 
                        style={{
                            background:color, 
                            opacity:"0.3"
                        }} 
                    />
                )
            } else {
                tab.push(
                    <TableCell
                        key={color} 
                        onClick={() => this.handleChange(color)} 
                        style={{
                            background:color, 
                            cursor: "pointer", 
                            border: (this.props.selected === color && "2px solid blue"),
                        }} 
                    />
                )
            }
        }       
        return tab       
    }
    handleChange = (color) => {
        this.props.setColor(color)
    }
    render() {
        return (
            <div>
                <Table>
                    <TableBody>
                        {this.displayList()}
                    </TableBody>
                </Table>
            </div>
        );
    }
}

export default ColorPicker;